import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { getSingleDataFromDatabase } from "../utils/api";
import { toast } from "react-toastify";

const ReportNavBar = () => {
    const navigate = useNavigate();
    const ppcid = localStorage.getItem("ppcdata");
    const [ppc, setPPC] = useState({});

    const { pathname } = useLocation();

    // Detect active child routes for mega menus
    const isHourlyCallMenuActive =
        pathname.includes("/hourly-today-report") ||
        pathname.includes("/today-live-call-reports") ||
        pathname.includes("/hour-wise-call-report") ||
        pathname.includes("/day-wise-call-report") ||
        pathname.includes("/process-report");

    const isTodayCallMenuActive =
        pathname.includes("/today-team-report");

    const isTodayCenterCallMenuActive =
        pathname.includes("/center-live-call-report");

    const isManagementMenuActive =
        pathname.includes("/center-performance-report") ||
        pathname.includes("/agent-performance-report") ||
        pathname.includes("/top-product-by-state") ||
        pathname.includes("/product-performance-report") ||
        pathname.includes("/top-product-by-cluster-head");



    useEffect(() => {
        if (!ppcid) {
            navigate("/");
            return;
        }
        (async () => {
            try {
                const res = await getSingleDataFromDatabase(`ppc-get-single-data/${ppcid}`);
                if (res?.data?.status === 1) setPPC(res.data.ppcdata || {});
                else toast.error(res?.data?.message || "Failed to load PPC data");
            } catch (e) {
                console.error(e);
                toast.error("Network/CORS error while loading PPC data");
            }
        })();
    }, [ppcid, navigate]);


    const canSeeReports = Number(ppc?.ppc_report) === 1;
    const canSeeTeams = Number(ppc?.ppc_team) === 1;
    const canSeeCenter = Number(ppc?.ppc_report_center) === 1;

    return (
        <div>

            <div className="page-wrapper mb-1">
                <div className="reportdiv">
                    <ul className="reportlink">
                        <li className={`btnreport center-menu ${isHourlyCallMenuActive ? "parent-active" : ""}`}>
                            <span className="center-menu-label">Call Reports ▾</span>
                            <ul className="center-submenu">
                                <li>
                                    <NavLink to="/hourly-today-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Hourly Live Call
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/today-live-call-reports"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        T’day Live Calls
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/hour-wise-call-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Hour Wise Report
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/day-wise-call-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Days Wise Report
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink to="/process-report"
                                        className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                        Process Wise Last 7d
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        {canSeeTeams && (
                            <li className={`btnreport center-menu ${isTodayCallMenuActive ? "parent-active" : ""}`}>
                                <span className="center-menu-label">Teams Call Reports ▾</span>
                                <ul className="center-submenu">
                                    <li>
                                        <NavLink to="/today-team-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Team Wise Live Calls
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                        )}
                        {canSeeCenter && (
                            <li className={`btnreport center-menu ${isTodayCenterCallMenuActive ? "parent-active" : ""}`}>
                                <span className="center-menu-label">Other Reports ▾</span>
                                <ul className="center-submenu">
                                    <li>
                                        <NavLink to="/center-live-call-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Center Live Call
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                        )}
                        {canSeeReports && (
                            <li className={`btnreport center-menu ${isManagementMenuActive ? "parent-active" : ""}`}>
                                <span className="center-menu-label">Management Reports ▾</span>
                                <ul className="center-submenu">
                                    <li>
                                        <NavLink to="/center-performance-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Center Performance
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/agent-performance-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Agent Performance
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/top-product-by-state"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Top Product By State
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/product-performance-report"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Product Performance
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink to="/top-product-by-cluster-head"
                                            className={({ isActive }) => `center-submenu-link ${isActive ? 'center-submenu-link--active' : ''}`}>
                                            Top Product By Cluster Head
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ReportNavBar;
